import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { BOOKING_REQUEST_STATUS } from 'src/consumer/constants'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { getBookingRequestsForMentor } from 'src/consumer/services/featureServices'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { isTokenInvalidOrAbsent } from './login/ProtectedRoute'

export const BookingRequestNavigationAndToastComponent = () => {
  const { profileData, authToken } = useContext(ProfileContext)
  const navigate = useNavigate()

  const [data, setData] = useState([])

  async function getAllInitiatedBookingRequests() {
    let toReturn = []
    const localToken = localStorage.getItem('token')

    if (isTokenInvalidOrAbsent(authToken) || isTokenInvalidOrAbsent(localToken)) {
      setData([])
      return
    }

    if (profileData && profileData?.authorities?.includes('ROLE_TEACHER')) {
      let response = await getBookingRequestsForMentor(
        dayjs().utc().subtract(24, 'hours').format('YYYY-MM-DDTHH:mm:ss[Z]'),
        true,
      )

      if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
        const initiatedRequests = (response?.data?.data?.bookingRequests || []).filter(
          (item) => item?.status === BOOKING_REQUEST_STATUS.BOOKING_INITIATED,
        )
        toReturn = initiatedRequests
      }
      setData(toReturn)
    }

    return
  }

  function navigateToThePage() {
    if (data?.length > 0) {
      toast.success('You have unanswered Booking Requests')
      navigate('/booking-requests-for-mentors/all')
    }
  }

  useEffect(() => {
    getAllInitiatedBookingRequests()
  }, [authToken, profileData])

  useEffect(() => {
    navigateToThePage()
  }, [data])

  return <></>
}
export default BookingRequestNavigationAndToastComponent
